export default {
    sidebar: 'AI Agents',
    title: 'AI Agents',
    subtitle: 'Manage tokens that let AI assistants (Claude, ChatGPT, etc.) connect to your account.',
    oauthBadge: 'OAuth',
    manualBadge: 'Manual',

    manageBanner: 'Each token gives an AI agent ongoing access to your clients\' health data. Revoke any you\'re not actively using.',

    scopeDescriptions: {
        'read': 'Read your athlisis data — clients, measurements, questionnaires, food database, plan templates, profile. Includes your clients\' health data.',
        'write:plans': 'Create and update plan templates',
    },

    accessWarning: {
        title: 'Important — please read before granting access',
        scope: 'The agent will have ongoing access to read (and, with write scopes, modify or delete) data within the permissions you grant — including measurements, intake questionnaires, and other sensitive health data belonging to your clients.',
        responsibility: 'As the data controller, you must hold your clients\' explicit consent to share their health data with the AI systems you choose. AI does not replace your clinical judgment — treat agent output as suggestions, not as diagnoses or medical advice.',
        revocation: 'athlisis cannot audit what the agent does on your behalf. You can revoke access at any time, but actions already taken — including deletions — cannot be undone.',
    },

    acknowledgments: {
        heading: 'Please confirm:',
        consent: 'I have explicit consent from my clients to share their health data with the AI systems I authorize.',
        responsibility: 'I take clinical responsibility for every decision I make based on output from this agent.',
        notMedicalAdvice: 'I understand that athlisis is not responsible for the agent\'s use of my data or any conclusions it produces.',
    },

    create: '+ New token',
    createTitle: 'Create new token',
    nameLabel: 'Name',
    namePlaceholder: 'e.g. "Claude Desktop", "ChatGPT on laptop"',
    scopesLabel: 'Access permissions',
    createButton: 'Create',

    copyWarning: 'Copy this token now — it will not be shown again. If you lose it, revoke it and create a new one.',
    tokenLabel: 'Your new token',
    copy: 'Copy',
    copied: 'Copied!',
    howToUse: 'How to use it:',
    done: 'Done',

    connectionGuides: {
        heading: 'How to connect your AI assistant',
    },

    empty: 'No connected AI agents yet',
    emptyText: 'Click “New token” to get started.',
    revoke: 'Revoke',
    revoked: 'Revoked',
    revokeConfirm: 'Are you sure you want to revoke the token "{name}"? It will stop working immediately.',
    created: 'Created',

    grant: {
        title: 'Authorize agent',
        loading: 'Loading…',
        wantsAccess: 'wants to access your athlisis account',
        heading: 'Allow {name} to access your athlisis account?',
        subtitle: 'Approving will issue a token to this agent. You can revoke it anytime from your account settings.',
        redirectLabel: 'You will be returned to:',
        scopesHeader: 'Permissions requested:',
        allow: 'Allow access',
        deny: 'Cancel',
        unknownRequester: 'An AI agent',
        errorTitle: 'Cannot complete request',
        backToDashboard: 'Back to settings',
        errors: {
            missingRedirect: 'No return URL was provided. Ask the agent for a valid connect link.',
            invalidRedirect: 'The return URL is malformed.',
            unsafeRedirect: 'The return URL must use https (or http://localhost).',
            noValidScopes: 'The agent did not request any valid permissions.',
            loadFailed: 'Could not load permission details. Please try again.',
            grantFailed: 'Granting access failed. Please try again.',
            missingClient: 'The agent did not identify itself.',
            missingChallenge: 'The agent did not provide a PKCE code challenge.',
        },
    },
};
